import { ChangeEvent, useEffect, useState } from 'react'

interface IProps {
  options: any
  label: any
  required?: any
  errors?: any
  isActive?: any
  readOnly?: boolean
  type?: string
}

const FormInput = ({
  options,
  label,
  required,
  errors,
  isActive,
  readOnly,
  type,
  ...rest
}: IProps) => {
  const [focused, setFocused] = useState(false)
  const [active, setActive] = useState(false)

  const handleTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.target.value.length > 0 ? setActive(true) : setActive(false)
  }

  useEffect(() => {
    if (isActive) setActive(true)
  }, [])

  const inputId = `form-input-${options.name}`

  return (
    <div
      className={`relative my-4 flex ${
        type === 'checkbox' ? 'flex-row-reverse' : 'flex-col'
      }`}
    >
      <label
        htmlFor={inputId}
        className='left-4 font-medium px-1 transition-all duration-150 pointer-events-none'
      >
        {label}
      </label>
      <input
        id={inputId}
        readOnly={readOnly}
        onKeyUp={handleTextChange}
        className='rounded-md border bg-white border-gray-200 h-12 w-full focus:outline-primary px-5'
        {...options}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        type={type}
        aria-invalid={errors[options.name] ? 'true' : undefined}
        aria-describedby={errors[options.name] ? `${inputId}-error` : undefined}
        {...rest}
      />
      {errors[options.name] && (
        <p
          id={`${inputId}-error`}
          className='text-sm font-normal text-error'
          role='alert'
          aria-live='polite'
        >
          {errors[options.name].message}
        </p>
      )}
    </div>
  )
}

export default FormInput
